var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.5607 9.06066C20.1464 8.47487 20.1464 7.52513 19.5607 6.93934C18.9749 6.35355 18.0251 6.35355 17.4393 6.93934L6.93934 17.4393C6.79553 17.5832 6.68702 17.7489 6.61382 17.9258C6.54048 18.1027 6.5 18.2966 6.5 18.5C6.5 18.7034 6.54048 18.8973 6.61382 19.0742C6.68702 19.2511 6.79553 19.4168 6.93934 19.5607L17.4393 30.0607C18.0251 30.6464 18.9749 30.6464 19.5607 30.0607C20.1464 29.4749 20.1464 28.5251 19.5607 27.9393L11.6213 20H29C29.8284 20 30.5 19.3284 30.5 18.5C30.5 17.6716 29.8284 17 29 17H11.6213L19.5607 9.06066Z","fill":"#153E67"}));
}

Back.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Back;

Back.default = Back;
